export function buildComponentUrl ({
  companyId,
  siteId = null,
  assetId = null
}) {
  if (assetId) {
    return `/assets/${assetId}/components`
  }
  if (siteId) {
    return `/company/${companyId}/sites/${siteId}/components`
  }
  return `/company/${companyId}/components`
}
